/**
 * @fileoverview Axios request configuration derived from the environment.
 * @description Centralizes the API base URL and request timeout used to create the shared Axios
 * instance, so a change to VITE_API_URL is the only edit needed to point the app elsewhere. The
 * "/api/v1" version prefix is appended here rather than baked into every environment's VITE_API_URL
 * so bumping the API version is a one-line code change, not an every-environment env edit.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { env } from '@/config/env'

export const apiConfig = {
  baseUrl: `${env.apiBaseUrl}/api/v1`,
  timeoutMs: 15000,
}
